import { Injectable } from '@angular/core';
import { TranslationService } from '@dch/ng-common';
import { BRAND } from 'src/app/my-bill/config/my-bill.constants';

@Injectable()
export class MyScarletService {
  constructor(private translationService: TranslationService) {}

  // For Scarlet users only pdf bill will be available

  isScarlet(): boolean {
    return (
      this.translationService.getTranslatedValueFor('app.brand') ===
      BRAND.SCARLET
    );
  }

  isScarletUserWithMigratedInvoice(billDocumentReference: string): boolean {
    return (
      this.isScarlet() && this.isThirdCharacterALetter(billDocumentReference)
    );
  }

  isThirdCharacterALetter(billDocumentReference: string) {
    const thirdCharacter = billDocumentReference.charAt(2);
    return /^[a-zA-Z]$/.test(thirdCharacter);
  }
}
